'use client';

import { ListItemText, MenuItem, Select } from '@mui/material';

import type { ChartType } from '@/types/dashboard';

const CHART_TYPE_OPTIONS: {
  value: ChartType;
  label: string;
  symbol: string;
}[] = [
  { value: 'BAR', label: 'Bar', symbol: '\u2587' },
  { value: 'LINE', label: 'Line', symbol: '\u2571' },
  { value: 'AREA', label: 'Area', symbol: '\u25E2' },
  { value: 'PIE', label: 'Pie', symbol: '\u25CF' },
  { value: 'DONUT', label: 'Donut', symbol: '\u25CB' },
  { value: 'SCATTER', label: 'Scatter', symbol: '\u00B7\u00B7' },
  { value: 'TABLE', label: 'Table', symbol: '\u2637' },
];

interface ChartTypePickerProps {
  value: ChartType;
  onChange: (type: ChartType) => void;
}

export function ChartTypePicker({ value, onChange }: ChartTypePickerProps) {
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value as ChartType)}
      size='small'
      sx={{ minWidth: 140 }}
      renderValue={(selected) => {
        const option = CHART_TYPE_OPTIONS.find((o) => o.value === selected);
        if (!option) return selected;
        return (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span
              style={{
                fontSize: 16,
                color: 'var(--mui-palette-text-secondary)',
              }}
            >
              {option.symbol}
            </span>
            {option.label}
          </span>
        );
      }}
    >
      {CHART_TYPE_OPTIONS.map(({ value: v, label, symbol }) => (
        <MenuItem key={v} value={v}>
          <span
            style={{
              marginRight: 8,
              fontSize: 16,
              minWidth: 20,
              textAlign: 'center',
              color: 'var(--mui-palette-text-secondary)',
            }}
          >
            {symbol}
          </span>
          <ListItemText>{label}</ListItemText>
        </MenuItem>
      ))}
    </Select>
  );
}
